module.exports = __webpack_public_path__ + "static/media/logo-innovate.6a2b13be.png";